import { ProfileType, ProfileTypeCodes } from "@src/types";

export const transformProfileTypeId = (profileTypeId?: ProfileTypeCodes): "Owner" | "Tenant" | "OwnerTenant" => {
  const { owner, tenant } = ProfileType;

  if (profileTypeId === owner) return "Owner";
  if (profileTypeId === tenant) return "Tenant";
  return "OwnerTenant";
};
